import { action, observable, makeObservable } from "mobx";

import CouponsAPI from "../api/CouponsAPI";
import { Coupon } from "../models/inventory/Coupon";
import { CouponFilters } from "../models/inventory/CouponsFilters";
import {
  APIBlobResponse,
  APIResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";

export class CouponStore {
  coupons: Coupon[];
  couponsAPI: CouponsAPI;
  limit: number;
  total_pages: number;
  total_count: number;

  constructor() {
    this.coupons = [];
    this.couponsAPI = new CouponsAPI();

    this.limit = 0;
    this.total_count = 0;
    this.total_pages = 0;

    makeObservable(this, {
      coupons: observable,
      getCoupons: action,
      downloadReport: action,
      sendReminders: action,
    });
  }

  getCoupons = async (filters: CouponFilters) => {
    try {
      const response = (await this.couponsAPI.getCoupons(
        filters,
        false
      )) as PaginatedAPIResponse<Coupon>;
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
      this.coupons = response.list;
    } catch (error: any) {
      throw error;
    }
  };

  downloadReport = async (filters: CouponFilters): Promise<APIBlobResponse> => {
    try {
      const response = (await this.couponsAPI.getCoupons(
        filters,
        true
      )) as APIBlobResponse;
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  downloadShipmentsReport = async (
    filters: CouponFilters
  ): Promise<APIBlobResponse> => {
    try {
      const response = (await this.couponsAPI.getCouponsShipments(
        filters,
        true
      )) as APIBlobResponse;
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  sendReminders = async (couponIds: number[]): Promise<APIResponse> => {
    try {
      const response = await this.couponsAPI.sendReminders(couponIds);
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  reactivateCoupons = async (
    filters: CouponFilters,
    couponIds: number[]
  ): Promise<APIResponse> => {
    try {
      const response = await this.couponsAPI.reactivateCoupons(
        filters,
        couponIds
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  };

  expireCoupons = async (
    filters: CouponFilters,
    couponIds: number[]
  ): Promise<APIResponse> => {
    try {
      const response = await this.couponsAPI.expireCoupons(filters, couponIds);
      return response;
    } catch (error: any) {
      throw error;
    }
  };
}
